// extracted by mini-css-extract-plugin
export default {"reminderNote":"reminder-note_reminderNote__IqQnD","warningIcon":"reminder-note_warningIcon__GmZHM"};